import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import { fetchQueryData } from 'hooks/use-gremlin-query'

import type { AxiosError } from 'axios'
import type { TeamInfo } from 'types/api/orgs/team'

export const orgsQueryKeys = {
  oneById: ({ identifier }: { identifier: string }) =>
    ['orgs', identifier] as const
}

function fetchTeamInfo({
  queryKey: [endpoint, identifier]
}: QueryFunctionContext<ReturnType<typeof orgsQueryKeys.oneById>>) {
  return fetchQueryData<TeamInfo[]>(`${endpoint}/${identifier}`)
}

export function useGetTeamInfo(
  identifier: string,
  queryOptions: Omit<
    UseQueryOptions<TeamInfo[], AxiosError>,
    'queryKey' | 'queryFn'
  > = {}
) {
  return useQuery({
    ...queryOptions,
    queryFn: fetchTeamInfo,
    queryKey: orgsQueryKeys.oneById({ identifier })
  })
}
